import Skeleton from '@mui/material/Skeleton';
import { Card } from 'modules/shared/components';
import { PROJECT_STATUS_MAP } from 'modules/work-implementation/constants';

// }
export default function CommonJobDetails({ loading, projectData = {} }: { loading?: any; projectData?: Record<string, any> }) {
  if (loading) {
    return <Skeleton variant='rounded' width='100%' height={40} />;
  }

  return (
    <Card>
      <div className='row row--between'>
        <span>{projectData.code}</span>
        <span>{projectData.date}</span>
        <span>{projectData.name}</span>
        <span>{PROJECT_STATUS_MAP[projectData.status] ?? projectData.status}</span>
      </div>
      <div className='row row--between'>
        <div className='row gap-1'>
          <span className='font-medium'>Job Owner:</span>
          <span>{projectData.owner}</span>
        </div>
        <div></div>
        <div className='row gap-1'>
          <span className='font-medium'>Job value:</span>
          <span>{projectData.value}</span>
        </div>
        <div className='row gap-1'>
          <span className='font-medium'>Milestones:</span>
          <span>
            {projectData.completedMilestones} / {projectData.totalMilestones}
          </span>
        </div>
      </div>
    </Card>
  );
}
